import React, { FC, memo, useEffect, useRef, useMemo, useState } from "react";
import { createUseStyles } from "react-jss";

import { areEqualShallow } from "Utils/areEqual";
import GeolocationImage from "Assets/images/geolocation.svg";
import { setGeoLocationGlobalContext } from "../../analyticsManager/trackers/gainsightGlobalContextUtils";
import styles from "./styles";

interface Props {
  mapObj: any;
}

const Geolocation: FC<Props> = memo((props: Props) => {
  const useStyles = createUseStyles(styles);
  const classes = useStyles({ ...props });
  const { mapObj } = props;
  const markerRef = useRef(null);
  const [markerPosition, setMarkerPosition] = useState(null);

  useMemo(() => {
    if (markerPosition?.coords) {
      if (markerRef.current) {
        // move our marker
        markerRef.current.setPosition(
          new window.google.maps.LatLng(
            markerPosition.coords.latitude,
            markerPosition.coords.longitude
          )
        );
      } else {
        // create a marker
        markerRef.current = new window.google.maps.Marker({
          position: new window.google.maps.LatLng(
            markerPosition.coords.latitude,
            markerPosition.coords.longitude
          ),
          map: mapObj.map,
          icon: `${process.env.REACT_APP_BASE_URL}images/geolocation_full_blue.svg`,
        });
      }
      setGeoLocationGlobalContext(true);
    }
  }, [mapObj, markerPosition]);

  useEffect(() => {
    const onGoePosition = (position) => {
      setMarkerPosition(position);
    };
    /* eslint-disable no-unused-expressions */
    navigator?.geolocation?.watchPosition(onGoePosition, () => {}, {
      maximumAge: 0,
      timeout: 10000,
      enableHighAccuracy: true,
    });
  }, [mapObj, markerPosition]);

  const showLocation = () => {
    // If we have a marker position, lets center on it because the user pressed LocateMe
    if (markerPosition) {
      const geoPt = mapObj.toGoogleLatLng(
        markerPosition.coords.latitude,
        markerPosition.coords.longitude
      );
      if (geoPt && mapObj.isInBounds(geoPt)) {
        mapObj.setCenter({
          lat: markerPosition.coords.latitude,
          lng: markerPosition.coords.longitude,
        });
        return;
      }
    }
    // eslint-disable-next-line no-alert
    window.alert("You seem far away, we can't locate you right now.");
  };

  return (
    <button
      type="button"
      aria-label="Geolocation"
      className={classes.container}
      onClick={showLocation}
      id="geolocation"
      data-testid="geolocation"
    >
      <GeolocationImage />
    </button>
  );
}, areEqualShallow);

export default Geolocation;
try {
    // @ts-ignore
    Geolocation.displayName = "Geolocation";
    // @ts-ignore
    Geolocation.__docgenInfo = { "description": "", "displayName": "Geolocation", "props": { "mapObj": { "defaultValue": null, "description": "", "name": "mapObj", "required": true, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/Geolocation/Geolocation.tsx#Geolocation"] = { docgenInfo: Geolocation.__docgenInfo, name: "Geolocation", path: "src/shared/components/Geolocation/Geolocation.tsx#Geolocation" };
}
catch (__react_docgen_typescript_loader_error) { }